import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/back_btn.png'


const _hoisted_1 = { class: "page-webview" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _ctx.webviewUrl,
      width: "100%",
      frameborder: "no",
      marginwidth: "0",
      marginheight: "0",
      allowtransparency: "true"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: "back-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
    }, _hoisted_4)
  ]))
}